import multipleUISelectTemplate from './multipleUISelect.html';

/** @ngInject */
export function multipleSelect() {
    return {
        restrict: 'E',
        scope: {
            kind: '=',
            avList: '=',
            filterType: '=',
            property: '=',
            ngDisabled: '=',
            isRequired: '=',
            name: '=',
        },
        transclude: 'true',
        templateUrl: multipleUISelectTemplate
    };
}
